import { render, staticRenderFns } from "./people-verify.vue?vue&type=template&id=3713c7c2&"
import script from "./people-verify.vue?vue&type=script&lang=js&"
export * from "./people-verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3713c7c2')) {
      api.createRecord('3713c7c2', component.options)
    } else {
      api.reload('3713c7c2', component.options)
    }
    module.hot.accept("./people-verify.vue?vue&type=template&id=3713c7c2&", function () {
      api.rerender('3713c7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/peopleVerify/components/people-verify.vue"
export default component.exports